export const MESSAGE = {
  // WEARABLES -> APP
  MODEL_LOADED: "model-loaded",
  GENERATOR_MODEL_RENDERED: "rendered",
  GENERATOR_CLOSE: "generator-close",
  TOO_LARGE_FILE: "wearables-file-too-large",
  PRINTS_NUMBER: "wearables-prints-number",
  // APP -> WEARABLES
  SET_DISABLED: "wearables-disabled",
};

class WearablesService {
  static setDisabled(): void {
    if (typeof window === "undefined") return;
    window?.postMessage(
      {
        name: MESSAGE.SET_DISABLED,
        disableButtons: true,
      },
      "*",
    );
  }
}

export default WearablesService;
